export class ListDataCatalogDatasetsFlatRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogName",
            "baseName": "catalogName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogDatasetsFlatRequest.attributeTypeMap;
    }
    constructor() {
    }
}
